module.exports = __webpack_public_path__ + "static/media/chevron-down.2f798a2f.svg";